var map = {
	"./address_image.svg": 3906,
	"./animated_ashutosh.png": 8009,
	"./animated_logo.svg": 9083,
	"./blogs_image.svg": 7245,
	"./certificate_bitrix.jpeg": 7161,
	"./certificate_codesignal.png": 3717,
	"./certificate_fullstack.png": 6201,
	"./certificate_google.png": 8967,
	"./certificate_js.jpeg": 364,
	"./certificate_kotlin.jpeg": 1150,
	"./certificate_microsoft.png": 1240,
	"./certificate_python.jpg": 7160,
	"./certificate_python_1.jpeg": 8401,
	"./certificate_upwork.png": 5754,
	"./cloud_infrastructure.svg": 883,
	"./codeInLogo.png": 7873,
	"./contactMail.png": 3189,
	"./coursera_logo.png": 1170,
	"./data_science.svg": 8699,
	"./deeplearning_ai_logo.png": 9575,
	"./delhivery_logo.png": 2582,
	"./developerActivity.svg": 9257,
	"./dsc_logo.png": 8750,
	"./education.svg": 1118,
	"./experience.svg": 7480,
	"./feelingProud.svg": 8294,
	"./freecopy_logo.png": 4633,
	"./fullstack.svg": 5137,
	"./gcp_logo.png": 1525,
	"./github_logo.png": 8017,
	"./googleAssistant.jpg": 1659,
	"./googleAssistant.svg": 7291,
	"./google_logo.png": 9389,
	"./ibm_logo.png": 262,
	"./iiitk_logo.png": 6200,
	"./intel_logo.jpg": 8504,
	"./iu_logo.png": 6056,
	"./jsFramework.svg": 9655,
	"./legato_logo.png": 1236,
	"./logo_fsoft.png": 4992,
	"./logo_interactivepartners.png": 5199,
	"./logo_milestone.png": 7620,
	"./logo_saint.png": 7061,
	"./logo_vv.png": 884,
	"./logo_webuspeh.jpg": 4477,
	"./manOnTable.svg": 7473,
	"./microsoft_logo.png": 752,
	"./mozilla_logo.png": 6816,
	"./muffito_logo.png": 9556,
	"./nextuLogo.jpg": 8497,
	"./nptel_logo.png": 7439,
	"./portfolio.gif": 8467,
	"./programmer.svg": 4700,
	"./projects_image.svg": 8859,
	"./pwa.png": 9180,
	"./saayaHealthLogo.png": 4176,
	"./stanford_logo.png": 6691,
	"./talksCardBack.svg": 6654,
	"./talksCardBackAlt.svg": 3291,
	"./tiktok_logo.png": 3292,
	"./ui_ux_design.svg": 9163,
	"./vinhnt_art.jpg": 1415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;